(() => {
    try {
      const getCurrentPWS = () => {
        const urlParams = new URLSearchParams(window.location.search);
  
        const fallbackPWS = sessionStorage.getItem("404_PATH")?.split("/")?.at(1);
        sessionStorage.removeItem("404_PATH");
        if (fallbackPWS?.length) {
          return fallbackPWS;
        }
  
        const paramPWS = urlParams.get("pws");
        if (paramPWS) return paramPWS;

        const localPWS = localStorage.getItem("CURRENT_SITE");
        if (localPWS) return localPWS;
  
        const paramAls = urlParams.get("als");
        if (paramAls) return paramAls;
        return null;
      };
  
      const getPreferredPWS = async () => {
        const sessionPWS = sessionStorage.getItem("PREFERRED_SITE");
        if (sessionPWS) return sessionPWS;
  
        const preferredAdvocateId = window?.customer?.preferredAdvocateId;
        if (preferredAdvocateId) {
          const partner = await window.backend.getPartnerByAdvocateId(
            preferredAdvocateId
          );
          if (partner?.siteName?.length) {
            return partner.siteName;
          }
        }
  
        return null;
      };
  
      const loadTrackingInfo = () => {
        if (!sessionStorage.getItem("TRACKING_LANDING_URL")) {
          sessionStorage.setItem("TRACKING_LANDING_URL", window.location.href);
        }
  
        if (!sessionStorage.getItem("TRACKING_REFERRER") && document.referrer) {
          sessionStorage.setItem("TRACKING_REFERRER", document.referrer);
        }
      };
  
      function updateUrlPWS(pws) {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set("pws", pws);
  
        // Preserve the hash value if it exists
        const hashValue = window.location.hash;
  
        // Update URL while maintaining the hash
        window.history.replaceState(
          {},
          "",
          window.location.pathname + "?" + urlParams.toString() + hashValue
        );
      }
  
      async function applyAttribution() {
        loadTrackingInfo();
        const currentPWS = getCurrentPWS();
        const preferredPWS = await getPreferredPWS();
  
        console.log("currentPWS", currentPWS);
        console.log("preferredPWS", preferredPWS);
  
        // Async handling
        if (window?.customer && window.customer?.isPartner && window.customer?.siteName) {
            console.log("window.customer", window.customer);
          updateUrlPWS(window.customer.siteName);
          localStorage.setItem("CURRENT_SITE", window.customer.siteName);
        } else if (currentPWS || preferredPWS) {
          const partner = await window.backend.getPartnerBySite(
            currentPWS || preferredPWS, false
          );

          if (partner?.siteName?.length) {
            updateUrlPWS(partner.siteName);
            localStorage.setItem("CURRENT_SITE", partner.siteName);
            window.partner = partner;
            document.dispatchEvent(
              new CustomEvent("theme:partner:update", { detail: { partner } })
            );
            document.dispatchEvent(
              new CustomEvent("theme:partner:render", { detail: { partner } })
            );
          }

          if (currentPWS && preferredPWS && currentPWS !== preferredPWS) {
            (async () => {
              const currentPartner = await window.backend.getPartnerBySite(
                currentPWS
              );
              const preferredPartner = await window.backend.getPartnerBySite(
                preferredPWS
              );

              console.log("currentPartner", currentPartner);
              console.log("preferredPartner", preferredPartner);

              if (currentPartner && preferredPartner) {
                document.dispatchEvent(
                  new CustomEvent("theme:partner:mismatch", {
                    detail: {
                      current: currentPartner,
                      preferred: preferredPartner,
                    },
                  })
                );
              }
            })();
          }
        }
      }
  
      document.addEventListener("DOMContentLoaded", applyAttribution);
  
      // Re-apply attribution when returning from checkout (or any navigation) via back button.
      // When the page is restored from bfcache, DOMContentLoaded does not fire again.
      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          applyAttribution();
        }
      });
    } catch (e) {
      console.error(e);
    }
  })();
  